export default [
  {
    routeName: 'user_module_comsaEnvironmental_office',
    title: 'office',
    type: 'office',
    icon: 'file-list-3',
    color: '#17A2B8',
  },
  {
    routeName: 'user_module_comsaEnvironmental_office_normal_environmental_aspects',
    title: 'office.normal.environmental.aspects',
    type: 'office_normal_environmental_aspects',
    icon: 'leaf',
  },
  {
    routeName: 'user_module_comsaEnvironmental_office_emergency_and_potential_environmental_aspects',
    title: 'office.emergency.and.potential.environmental.aspects',
    type: 'office_emergency_and_potential_environmental_aspects',
    icon: 'spam',
  },
  {
    routeName: 'user_module_comsaEnvironmental_office_changes_management',
    title: 'office.changes.management',
    type: 'office_changes_management',
    icon: 'arrow-left-right',
  },
  {
    routeName: 'user_module_comsaEnvironmental_office_notes_and_observations',
    title: 'office.notes.and.observations',
    type: 'office_notes_and_observations',
    icon: 'sticky-note',
  },
  {
    routeName: 'user_module_comsaEnvironmental_construction',
    title: 'construction',
    type: 'construction',
    icon: 'building-4',
    color: '#6C757D',
  },
  {
    routeName: 'user_module_comsaEnvironmental_construction_data_input',
    title: 'construction.data.input',
    type: 'construction_data_input',
    icon: 'draft',
  },
  {
    routeName: 'user_module_comsaEnvironmental_construction_design',
    title: 'design',
    type: 'construction_design',
    icon: 'quill-pen',
  },
  {
    routeName: 'user_module_comsaEnvironmental_construction_design_normal_aspects',
    title: 'design.normal.aspects',
    type: 'construction_design_normal_aspects',
    icon: 'pen-nib',
  },
  {
    routeName: 'user_module_comsaEnvironmental_construction_use_normal_aspects',
    title: 'use.normal.aspects',
    type: 'construction_use_normal_aspects',
    icon: 'open-arm',
  },
  {
    routeName: 'user_module_comsaEnvironmental_construction_control_card',
    title: 'construction.control.card',
    type: 'construction_control_card',
    icon: 'refund',
  },
  {
    routeName: 'user_module_comsaEnvironmental_construction_normal_aspects',
    title: 'construction.normal.aspects',
    type: 'construction_normal_aspects',
    icon: 'focus',
  },
  {
    routeName: 'user_module_comsaEnvironmental_construction_deconstruction_normal_aspects',
    title: 'deconstruction.normals',
    type: 'construction_deconstruction_normal_aspects',
    icon: 'building-3',
  },
  {
    routeName: 'user_module_comsaEnvironmental_construction_emergency_potentials_aspects',
    title: 'construction.emergency.potentials.aspects',
    type: 'construction_emergency_potentials_aspects',
    icon: 'spam',
  },
  {
    routeName: 'user_module_comsaEnvironmental_construction_ppi',
    title: 'construction.ppi',
    type: 'construction_ppi',
    icon: 'spy',
  },
  {
    routeName: 'user_module_comsaEnvironmental_industrial',
    title: 'industrial',
    type: 'industrial',
    icon: 'building-3',
    color: '#FFC107',
  },
  {
    routeName: 'user_module_comsaEnvironmental_industrial_data_input',
    title: 'construction.data.input',
    type: 'industrial_data_input',
    icon: 'draft',
  },
  {
    routeName: 'user_module_comsaEnvironmental_industrial_design_normal_aspects',
    title: 'design.normal.aspects',
    type: 'industrial_design_normal_aspects',
    icon: 'pen-nib',
  },
  {
    routeName: 'user_module_comsaEnvironmental_industrial_use_normal_aspects',
    title: 'use.normal.aspects',
    type: 'industrial_use_normal_aspects',
    icon: 'open-arm',
  },
  {
    routeName: 'user_module_comsaEnvironmental_industrial_control_card',
    title: 'construction.control.card',
    type: 'industrial_control_card',
    icon: 'refund',
  },
  {
    routeName: 'user_module_comsaEnvironmental_industrial_normal_aspects',
    title: 'construction.normal.aspects',
    type: 'industrial_normal_aspects',
    icon: 'focus',
  },
  {
    routeName: 'user_module_comsaEnvironmental_industrial_deconstruction_normal_aspects',
    title: 'deconstruction.normals',
    type: 'industrial_deconstruction_normal_aspects',
    icon: 'building-3',
  },
  {
    routeName: 'user_module_comsaEnvironmental_industrial_emergency_potentials_aspects',
    title: 'construction.emergency.potentials.aspects',
    type: 'industrial_emergency_potentials_aspects',
    icon: 'spam',
  },
  {
    routeName: 'user_module_comsaEnvironmental_industrial_ppi',
    title: 'industrial.ppi',
    type: 'industrial_ppi',
    icon: 'spy',
  },
];
